// Section anchors must not change the hash used by HashRouter.
export const handleSectionClick = (id) => (event) => {
  if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || (event.button !== undefined && event.button !== 0)) return;
  event.preventDefault();
  const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  (document.getElementById(id === "formularz" ? "formularz-pola" : id) || document.getElementById(id))?.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
};

